import { number, string, object, oneOf } from 'prop-types'
import { kuiperClassNames } from '../utils'
import { styles } from './styles'

const parsePercentage = (percentage) => {
  let parsedPercentage = Math.round(percentage)

  if (parsedPercentage < 0 || Number.isNaN(parsedPercentage))
    parsedPercentage = 0
  if (parsedPercentage > 100) parsedPercentage = 100

  return parsedPercentage
}

const formatPercentage = (percentage) => `${parsePercentage(percentage)}%`

const ProgressBar = ({
  fillColor = null,
  percent = 0,
  style,
  theme = 'dark',
}) => (
  <div css={styles.base(style)} className={kuiperClassNames('progress-bar')}>
    <div
      aria-label="Loading…"
      aria-valuemax={100}
      aria-valuemin={0}
      aria-valuenow={parsePercentage(percent)}
      css={styles.fill({
        color: fillColor,
        theme,
        width: formatPercentage(percent),
      })}
      className={kuiperClassNames('fill')}
      role="progressbar"
    />
  </div>
)

ProgressBar.propTypes = {
  fillColor: string,
  percent: number.isRequired,
  style: object,
  theme: oneOf(['dark', 'light']),
}

export default ProgressBar

export { formatPercentage, parsePercentage }
